<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />
    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement :info="basicRequirement" />
    <PositionSummary :info="positionInfo" />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../../../components/AssessmentIsa/AboutTheCompany.vue'
import TestimonialCompany from '../../../components/AssessmentIsa/CompanyTestimonial.vue'
import Landing from '../../../components/AssessmentIsa/LandingAssessment.vue'
import ProgramInfo from '../../../components/AssessmentIsa/ProgramInfo.vue'
import Contact from '../../../components/isaMain/Contact.vue'
import PositionSummary from '../../../components/AssessmentIsa/PositionSummary.vue'
import BasicRequirement from '../../../components/AssessmentIsa/BasicReq.vue'
import Faq from '../../../components/shera/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title1: 'Get Hired for the role of ',
        subTitle: 'Senior Marketing Executive (Contractual)',
        paragraph:
          'If you have what it takes to become a ‘Senior Marketing Executive’ at Bongo, take the assessment curated by Upskill in order to get selected. ',
        companyLogo: '',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/598495df-b370-40cb-a79f-ceac48bf6dfe?public=true&job=bongo_marketing',
        landingImage: require('../../../assets/bongo/Asset 1@2x.png'),
        spanColor: 'grey',
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar: require('../../../assets/bongo/Bongo_logo 1.png'),
        info:
          'Bongo is an international media-tech company that is empowering the masses through the creation, distribution, and monetization of video content. At Bongo, we believe access to content and media to be a right, not a privilege. Ultimately, this is what drives us every day in our mission to create a digital ecosystem catering to our key demographics in primarily frontier markets such as Bangladesh, India, etc. but also in other global markets such as Europe/N. America.',
        designation: '',

        bgColor: '#DDEAFA',
        txtColor: '#29292B',
      },
      programData: {
        headingInfo:
          'Senior Executive - Marketing Assessment consists of approximately 15 MCQs. You are required to pass an assessment test with a minimum of 60% of the total score.Top 5-10 Candidates will get the chance to go to the interview round after completing the assessment. So, don’t miss this opportunity as the time is limited!',
        seatsInfo: '',
        startDate: '15th February',
        cost: 'Free',
        deadline: '25th February',
        courseOutlineLink:
          'https://upskill-files.s3.ap-southeast-1.amazonaws.com/Financial+Analyst/Course+Outline+for+Financial+Analyst.pdf',

        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        bgColor: '#1EBCE5',
        txtColor: '#5277F7',
      },
      positionInfo: {
        paragraph:
          'Senior Executive is a full-time role (40/h week). The ideal candidate will have 2 years to 4 years of work experience in communications, campaigns, and marketing. If you’re knowledgeable about marketing campaigns, social media writing, and current media channels, we’d like to meet you. Job Level: 2 years to 4 years of previous work experience ',
        remote: '',
        jobType: 'Job Type: Full-time ',
        txtColor: '#5277F7',
      },
      companyTestimonial: {
        mainImg: require('../../../assets/bongo/CTO_Bongo_Shadid 1.png'),
        name: 'Shadid Haque',
        paragraph:
          'At Bongo we believe in human-centric designs because people ignore design that ignores people. We are very excited to team up with Upskill in our mission to recruit the very best talents from all walks of life. We welcome anyone who wants to solve problems that impact millions of users and be part of a team that is empowered to do so.',
        designation: 'CTO  of Bongo',
        imgBg: '#DDEAFA',
        invertedCommaBg: '',
        //   firstComma: require('../assets/Canadian Tech company/“.svg'),
        //   secondComma: require('../assets/Canadian Tech company/Group 22.svg'),
      },
      basicRequirement: {
        mainContent: [
          'Proven experience (2 years to 4 years) in Marketing. ',
          'Expertise in Marketing, social media branding, online communications, social media post writing, digital campaign, client handling',
          'University Graduate in Marketing. ',
          'The ideal candidate must be good in English and Bangla article/ PR writing. ',
          ' Good in MS PowerPoint, MS Word, and MS Excel. ',
          'Have good interpersonal skills and passion to work for innovative digital campaigns.',
        ],
        bgColor: '#184DBD',
      },

      outlineColor: {
        color: '#EA4424',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content: 'It is free',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content: 'Yes, 2 years to 4 years experience in Marketing. \n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score i.e. 6 out of 10',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.\n',
          category: 'FAQ',
        },
        {
          title: 'Will all the top 5 students get a job at Bongo?\n',
          content:
            'No, the top 5 students will get a chance to interview at Bongo, and will get the job depending on their performance in the interview.\n',
          category: 'FAQ',
        },
        {
          title: 'Salary?\n',
          content: ' Market Competitive Salary  \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
    PositionSummary,
  },
  created() {
    this.Loaded()
  },
}
</script>
